{
  "AlarmonnewabandonedcallLabel": "Allarme su nuova chiamata abbandonata:",
  "NAME": "AbandonedCallAlarm",
  "AbandonedCallAlarm_SectionHeader": "Allarme di chiamata abbandonata",
  "AbandonedCallAlarm_SectionPara": "È possibile attivare un allarme quando si verificano nuove chiamate abbandonate."
}